module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "initializer",
    class: ( _obj = {}, _obj[_vm.$style.root] = true, _obj[_vm.$style.loading] = _vm.loading, _obj )
  }, [(_vm.loading && !_vm.error) ? _c('loading') : _vm._e(), (_vm.error) ? _c('div', {
    staticClass: "error"
  }, [_vm._v("Error")]) : _vm._e(), (!_vm.loading && !_vm.error) ? _c('div', {
    staticClass: "hidden"
  }, [_c('dynamic-style', {
    attrs: {
      "variables": _vm.designCompiled.colors,
      "logo": _vm.designCompiled.logo || false
    }
  })], 1) : _vm._e(), (!_vm.loading && !_vm.error) ? _c('div', {
    directives: [{
      name: "key-combo",
      rawName: "v-key-combo",
      value: ('ctrl+shift+k o l o r'),
      expression: "'ctrl+shift+k o l o r'"
    }]
  }, [_c('color-picker', {
    class: {
      hidden: _vm.clientSwitchHidden
    },
    attrs: {
      "defaultColors": _vm.defaultDesign.colors || {},
      "clientColors": _vm.clientDesign.colors || {},
      "compiledColors": _vm.designCompiled.colors || {},
      "client": _vm.client,
      "config": _vm.designClone
    }
  })], 1) : _vm._e()], 1)
  var _obj;
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-96e25592"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/initializer/Initializer.vue
// module id = 953
// module chunks = 1